/* eslint-disable spaced-comment */
/* eslint-disable object-shorthand */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import ReactFC from 'react-fusioncharts';
import FusionCharts from 'fusioncharts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import Charts from 'fusioncharts/fusioncharts.charts';
import { isMobile } from 'react-device-detect';

//const colors = ['#098703', '#0bb703', '#51ce00', '#a7b6b1', '#dadada'];
const colors = ['#00BC6E', '#307F68', '#431F4D', '#EF7E77', '#E1CC77', '#2dc2ca'];

ReactFC.fcRoot(FusionCharts, Charts, FusionTheme);
FusionCharts.options.license({
  key:
    '2mA4mpE-11E2B4G1A2C2B5C3B3E3D2C4B3I4H-7lfB5B2kocctA1A4gqbE2F4D1F3C8B5C4E3C3A2G3A14A10B14A8D8uddH4C2B2lA7C8A3ag1wH2C2C5qD-17jD2E2F1qkiB8C2C7D3F4E2C3A1B8A7A5nf1g1D3G2KB5tpgC2A1E2B-7mA3FD4E1F-10F-10tG4B1B11B3D3F3G3E4H2D1D3A1D4E5r==',
  creditLabel: false,
});

const FusionChartsManager = ({ herkevTik, sumDepositText, pieRadius, sliceClickHandle }) => {
  const [chartData, setChartData] = useState([]);
  const updateChartData = () => {
    setChartData(herkevTik.map(herkev => ({ value: herkev.totalAfikPercent })));
  };
  useEffect(() => {
    updateChartData();
  }, [herkevTik]);

  const chartConfigs = {
    type: 'doughnut2d',
    dataFormat: 'json',
    containerBackgroundOpacity: '0',
    dataSource: {
      chart: {
        defaultCenterLabel: sumDepositText,
        pieRadius: pieRadius,
        theme: 'fusion',
        palettecolors: colors,
        doughnutRadius: '60%',
        centerLabelBold: true,
        centerLabelFontSize: '13',
        centerLabelBorderRadius: '50',
        centerLabelPadding: '0',
        baseFontSize: '20',
        labelFontColor: '231f20',
        bgAlpha: '20',
        showValues: false,
        captionPadding: '0',
        chartLeftMargin: '0',
        chartRightMargin: '0',
        chartTopMargin: '0',
        chartBottomMargin: '0',
        numberSuffix: '%',
      },
      data: chartData,
    },
    events: {
      slicingEnd: sliceClickHandle
    }
  };
  //const trackPlotClick  = function(evt, arg) {
  //   console.log('Pie  1 chart - Slice clicked', e.detail);
  // };
  // FusionCharts.addEventListener("onClick", function (eventObject) {
  //  console.log('Pie  1 chart - Slice clicked');

  //});
  //FusionCharts.addEventListener('change', event => {
  // console.log(event.target)
  // })
  // FusionCharts.addEventListener(
  //  'click ',
  // trackPlotClick ,
  // );
  // FusionCharts.addEventListener('trackPlotClick', myEventListener);
  // const myEventListener =()=> {
  // console.log("Pie  1 chart - Slice clicked", e.detail)
  // }

  return (
    <>
      <div aria-hidden="true" className={`${isMobile ? 'd-flex justify-content-center' : ''}`}>
        <ReactFC {...chartConfigs} />
      </div>
    </>
  );
};

export default FusionChartsManager;
